export const {
    REACT_APP_BASE_URL,
    REACT_APP_API_BASE_URL,
    REACT_APP_ENVIRONMENT,
    REACT_APP_FEATURE_FLAG_ABOUT_ME_SECTION,
    REACT_APP_FEATURE_FLAG_API_STATUS_SECTION,
    REACT_APP_FEATURE_FLAG_PROJECT_SECTION, 
    REACT_APP_LOGOUT_REDIRECT,
    REACT_APP_SUPABASE_EMAIL_REDIRECT_TO
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
